"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketAddApi = marketAddApi;
exports.marketDelete = marketDelete;
exports.marketDeleteApi = marketDeleteApi;
exports.marketDetailApi = marketDetailApi;
exports.marketInfo = marketInfo;
exports.marketList = marketList;
exports.marketListApi = marketListApi;
exports.marketPublish = marketPublish;
exports.marketPullDown = marketPullDown;
exports.marketSave = marketSave;
exports.marketSelectList = marketSelectList;
exports.marketUpdate = marketUpdate;
exports.marketUpdateApi = marketUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 集市 列表
 */
function marketListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/market/list',
    method: 'get',
    params: params
  });
}

/**
 * 集市 添加
 */
function marketAddApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/market/save',
    method: 'post',
    data: data
  });
}

/**
 * 集市 编辑
 */
function marketUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/market/update?id=".concat(data.id),
    method: 'post',
    data: data
  });
}

/**
 * 集市 删除
 */
function marketDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/market/delete",
    method: 'get',
    params: params
  });
}

/**
 * 集市 详情
 */
function marketDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/market/info',
    method: 'get',
    params: params
  });
}

/**
 * 集市下拉列表
 * @param
 */
function marketSelectList() {
  return (0, _request.default)({
    url: '/admin/platform/market/select',
    method: 'get'
  });
}

// 兼容迁入视图所使用的 API 方法名（与商户端一致）
function marketSave(data) {
  return (0, _request.default)({
    url: '/admin/platform/market/save',
    method: 'POST',
    data: data
  });
}
function marketList(pram) {
  var params = {
    page: pram.page,
    limit: pram.limit
  };
  if (pram.environmentType !== '' && pram.environmentType >= 0) params.environmentType = pram.environmentType;
  if (pram.marketName) params.marketName = pram.marketName;
  if (pram.marketType !== '' && pram.marketType >= 0) params.marketType = pram.marketType;
  if (pram.siteType !== '' && pram.siteType >= 0) params.siteType = pram.siteType;
  if (pram.status !== '' && pram.status >= 0) params.status = pram.status;
  return (0, _request.default)({
    url: '/admin/platform/market/list',
    method: 'get',
    params: params
  });
}
function marketUpdate(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market/update?id=".concat(pram.id),
    method: 'post',
    data: pram
  });
}
function marketDelete(id) {
  return (0, _request.default)({
    url: "/admin/platform/market/delete?id=".concat(id),
    method: 'get'
  });
}
function marketInfo(id) {
  return (0, _request.default)({
    url: "/admin/platform/market/info",
    method: 'get',
    params: {
      id: id
    }
  });
}
function marketPublish(data) {
  return (0, _request.default)({
    url: "/admin/platform/market/publish?id=".concat(data.id),
    method: 'post',
    params: data
  });
}
function marketPullDown(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market/pullDown?id=".concat(pram.id),
    method: 'post',
    data: pram
  });
}

// /**
//  * 集市活动 列表
//  */
// export function marketActivityListApi(params) {
//   return request({
//     url: '/admin/platform/market_activity/list',
//     method: 'get',
//     params
//   })
// }

// /**
//  * 集市活动 添加
//  */
// export function marketActivityAddApi(data) {
//   return request({
//     url: '/admin/platform/market_activity/save',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 集市活动 详情
//  */
// export function marketActivityDetailApi(params) {
//   return request({
//     url: '/admin/platform/market_activity/info',
//     method: 'get',
//     params
//   })
// }

// /**
//  * 集市活动 删除
//  */
// export function marketActivityDeleteApi(params) {
//   return request({
//     url: '/admin/platform/market_activity/delete',
//     method: 'get',
//     params
//   })
// }

// /**
//  * 集市活动 编辑
//  */
// export function marketActivityUpdateApi(data) {
//   return request({
//     url: `/admin/platform/market_activity/update?id=${data.id}`,
//     method: 'post',
//     data
//   })
// }

// /**
//  * 活动取消
//  */
// export function marketActivityCancelApi(data) {
//   return request({
//     url: `/admin/platform/market_activity/cancel?id=${data.id}`,
//     method: 'post',
//     data
//   })
// }

// /**
//  * 活动上架
//  */
// export function marketActivityPublishApi(data) {
//   return request({
//     url: `/admin/platform/market_activity/publish?id=${data.id}`,
//     method: 'post',
//     data
//   })
// }

// /**
//  * 活动下架
//  */
// export function marketActivityPullDownApi(data) {
//   return request({
//     url: `/admin/platform/market_activity/pullDown?id=${data.id}`,
//     method: 'post',
//     data
//   })
// }

// /**
//  * 获取报名配置
//  */
// export function marketActivitySettingApi(params) {
//   return request({
//     url: '/admin/platform/market_activity/getSetting',
//     method: 'get',
//     params
//   })
// }